import React from 'react';

const AccessAndServices = () => {
  return (
    <div>
       <p className='font-bebas text-[32px] text-[#1A1A1A] py-6'> AccessAndServices</p>

    </div>
  );
};

export default AccessAndServices;